import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FileEmail = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26.762 11.588L16.587 4.188C16.424 4.063 16.224 4 15.999 4C15.774 4 15.574 4.075 15.411 4.188L5.23599 11.588C4.46099 12.151 3.99899 13.063 3.99899 14.013V25.001C3.99899 26.651 5.34899 28.001 6.99899 28.001H24.999C26.649 28.001 27.999 26.651 27.999 25.001V14.013C27.999 13.063 27.537 12.15 26.761 11.588H26.762ZM16 6.237L25.337 13.037L15.999 19.762L6.66099 13.024L15.999 6.237H16ZM26 25C26 25.55 25.55 26 25 26H6.99999C6.44999 26 5.99999 25.55 5.99999 25V15.025L15.412 21.812C15.587 21.937 15.787 22 16 22C16.213 22 16.413 21.937 16.587 21.812L26 15.025V25Z" />
	</svg>
);

export default FileEmail;
